import { Form as BaseForm } from '@base-ui/react/form';
import type { ComponentProps } from 'react';
import { cx } from '../lib/styled.tsx';

export type FormProps = ComponentProps<typeof BaseForm>;

/**
 * A `<form>` that routes server-side errors back to the matching Field by name
 * through its `errors` prop, so a failed submit lands under the right control.
 */
export function Form({ className, ...props }: FormProps) {
  return <BaseForm className={cx('flex flex-col gap-4', className)} {...props} />;
}
